import { render } from "./MatchParticipantContact.vue?vue&type=template&id=fe868dde"
import script from "./MatchParticipantContact.vue?vue&type=script&lang=js"
export * from "./MatchParticipantContact.vue?vue&type=script&lang=js"
script.render = render

export default script